<app-header #header></app-header>
<app-navigation-bar (onBurgerClicked)="toggleDrawer()"></app-navigation-bar>
<app-drawer [open]="drawerIsOpen" (onClose)="drawerIsOpen=false"></app-drawer>

<div>
  <div class="top-section">

    <div class="section-content hero-container">
      <div class="hero-content">
        <div class="hero-image-wrapper">
          <img class="home-image" alt="iTunes movie deals - CheapCharts" src="./assets/images/home_page_image_1.png">
        </div>

        <div class="hero-text">
          <h1 class="home-page-title">
            <app-rich-text [text]="getString('homePageTitle')"></app-rich-text>
          </h1>

          <!-- Store Logos -->
          <div class="store-logos-section">
            <div class="store-logos-label">{{getString('comparePricesAcross')}}</div>
            <div class="store-logos-grid">
              <a class="store-logo-card" [routerLink]="'/' + getCountry() + '/itunes/' + getString('moviesUrl') + '/' + getString('onSaleUrl')">
                <div class="store-logo-icon apple-tv-icon">
                  <img src="./assets/images/store-icons/apple-tv.png" alt="Apple TV">
                </div>
                <span class="store-logo-name">Apple TV</span>
              </a>
              <a class="store-logo-card" [routerLink]="'/' + getCountry() + '/amazon/' + getString('moviesUrl') + '/' + getString('onSaleUrl')">
                <div class="store-logo-icon">
                  <img src="./assets/images/store-icons/prime-video.png" alt="Prime Video">
                </div>
                <span class="store-logo-name">Prime Video</span>
              </a>
              <a class="store-logo-card" *ngIf="getCountry() == 'us'" [routerLink]="'/' + getCountry() + '/vudu/' + getString('moviesUrl') + '/' + getString('onSaleUrl')">
                <div class="store-logo-icon">
                  <img src="./assets/images/store-icons/fandango.png" alt="Fandango">
                </div>
                <span class="store-logo-name">Fandango</span>
              </a>
              <a class="store-logo-card" *ngIf="getCountry() == 'us'" [routerLink]="'/' + getCountry() + '/google-play/' + getString('moviesUrl') + '/' + getString('onSaleUrl')">
                <div class="store-logo-icon">
                  <img src="./assets/images/store-icons/google-play.png" alt="Google Play">
                </div>
                <span class="store-logo-name">Google Play</span>
              </a>
            </div>
          </div>

          <div class="hero-features">
            <div class="hero-feature-card">
              <div class="feature-icon-wrapper">
                <span class="material-icons">sell</span>
              </div>
              <div class="hero-feature-text">
                <h2 class="h2-home" id="homePageSubtitle1"></h2>
              </div>
            </div>
            <div class="hero-feature-card">
              <div class="feature-icon-wrapper">
                <span class="material-icons">notifications_active</span>
              </div>
              <div class="hero-feature-text">
                <h2 class="h2-home"><app-rich-text [text]="getString('homePageSubtitle2')"></app-rich-text></h2>
              </div>
            </div>
            <div class="hero-feature-card">
              <div class="feature-icon-wrapper">
                <span class="material-icons">local_fire_department</span>
              </div>
              <div class="hero-feature-text">
                <h2 class="h2-home"><app-rich-text [text]="getString('homePageSubtitle3')"></app-rich-text></h2>
              </div>
            </div>
          </div>

          <div class="home-btn-container">
            <a class="home-btn" [routerLink]="'/' + getCountry() + '/itunes/' + getString('moviesUrl') + '/' + getString('onSaleUrl')">{{getString('seeTheOffers')}}</a>
          </div>
        </div>
      </div>
    </div>

  </div>

  <div class="center-section">

    <div class="section-content">
      <div class="section-title carousel-title">{{getString('topsellerToday')}}, {{todayDate}}</div>
      <!-- Platzhalter für die Topseller -->
      <div class="carousel-placeholder" *ngIf="!itemsItunes || !hasItems(itemsItunes)">
        <div class="loading-container">
          <div class="spinner-container txt-algn-cntr">
            <app-spinner></app-spinner>
          </div>
          <p>Loading topsellers...</p>
        </div>
      </div>
      <app-carousel *ngIf="itemsItunes && hasItems(itemsItunes)" [title]="'itunes'"
      [items]="itemsItunes"
      (onAddToWishlistClick)="addToWishlist($event, 'itunes')"
      (onAddToBlocklistClick)="addToBlocklist($event, 'itunes')"
      (onAddToOwnlistClick)="addToOwnlist($event, 'itunes')"
      (onRemoveFromWishlistClick)="removeFromWishlist($event, 'itunes')"
      (onRemoveFromOwnlistClick)="removeFromOwnlist($event, 'itunes')">
      </app-carousel>

      <!-- Vudu nur für US -->
      <div class="separator" *ngIf="getCountry() == 'us' && itemsVudu && hasItems(itemsVudu)"></div>
      <div class="carousel-placeholder" *ngIf="getCountry() == 'us' && (!itemsVudu || !hasItems(itemsVudu))">
        <div class="loading-container">
          <div class="spinner-container txt-algn-cntr">
            <app-spinner></app-spinner>
          </div>
          <p>Loading topsellers...</p>
        </div>
      </div>
      <app-carousel *ngIf="getCountry() == 'us' && itemsVudu && hasItems(itemsVudu)" [title]="'vudu'"
      [items]="itemsVudu"
      (onAddToWishlistClick)="addToWishlist($event, 'vudu')"
      (onAddToBlocklistClick)="addToBlocklist($event, 'vudu')"
      (onAddToOwnlistClick)="addToOwnlist($event, 'vudu')"
      (onRemoveFromWishlistClick)="removeFromWishlist($event, 'vudu')"
      (onRemoveFromOwnlistClick)="removeFromOwnlist($event, 'vudu')">
      </app-carousel>

      <!-- Amazon Prime Video nur für US und DE -->
      <div class="separator" *ngIf="(getCountry() == 'us' || getCountry() == 'de') && showAmazon() && itemsAmazon && hasItems(itemsAmazon)"></div>
      <div class="carousel-placeholder" *ngIf="(getCountry() == 'us' || getCountry() == 'de') && showAmazon() && (!itemsAmazon || !hasItems(itemsAmazon))">
        <div class="loading-container">
          <div class="spinner-container txt-algn-cntr">
            <app-spinner></app-spinner>
          </div>
          <p>Loading topsellers...</p>
        </div>
      </div>
      <app-carousel *ngIf="(getCountry() == 'us' || getCountry() == 'de') && showAmazon() && itemsAmazon && hasItems(itemsAmazon)" [title]="'amazonPrimeVideo'"
      [items]="itemsAmazon"
      (onAddToWishlistClick)="addToWishlist($event, 'amazon')"
      (onAddToBlocklistClick)="addToBlocklist($event, 'amazon')"
      (onAddToOwnlistClick)="addToOwnlist($event, 'amazon')"
      (onRemoveFromWishlistClick)="removeFromWishlist($event, 'amazon')"
      (onRemoveFromOwnlistClick)="removeFromOwnlist($event, 'amazon')">
    </app-carousel>
    </div>

  </div>

  <div class="info-section">
    <div class="section-content">
      <div class="section-title">{{getString('realUserReviews')}}</div>
      <app-user-reviews></app-user-reviews>
    </div>
  </div>

  <div class="search-section">

    <div class="section-content">
      <div class="section-title">{{getString('neverMissDealAgain')}}</div>
      <p class="wishlist-description">
        {{getString('wishlistDescription')}}
      </p>
      <div class="search-bar-container">
        <app-search-bar [showMedias]="false" [selectedItemType]="searchSelectedItemType" [placeholder]="getString('searchbarPlaceholder')" (onSearchClicked)="searchClicked($event)"></app-search-bar>
      </div>
      <div class="wishlist-features">
        <div class="wishlist-feature">
          <span class="material-icons wishlist-feature-icon">notifications_active</span>
          <span class="feature-text">{{getString('instantPriceAlerts')}}</span>
        </div>
        <div class="wishlist-feature">
          <span class="material-icons wishlist-feature-icon">savings</span>
          <span class="feature-text">{{getString('setTargetPrice')}}</span>
        </div>
        <div class="wishlist-feature">
          <span class="material-icons wishlist-feature-icon">devices</span>
          <span class="feature-text">{{getString('worksAllStores')}}</span>
        </div>
      </div>
    </div>

  </div>

  <div class="special-section">

    <div class="section-content">
      <div class="section-title">{{getString('whatMakesCheapChartsSpecial')}}</div>

      <div class="special-grid">
        <div class="special-card">
          <div class="special-card-icon">
            <span class="material-icons">travel_explore</span>
          </div>
          <div class="special-card-content">
            <h2 class="special-card-title">{{getString('home1stTitle')}}</h2>
            <p class="special-card-text" id="home1stSub" [innerHTML]="getHome1stSubText()"></p>
          </div>
        </div>

        <div class="special-card">
          <div class="special-card-icon">
            <span class="material-icons">bookmark_border</span>
          </div>
          <div class="special-card-content">
            <h2 class="special-card-title">{{getString('home2ndTitle')}}</h2>
            <p class="special-card-text">{{getString('home2ndSub')}}</p>
          </div>
        </div>

        <div class="special-card">
          <div class="special-card-icon">
            <span class="material-icons">movie</span>
          </div>
          <div class="special-card-content">
            <h2 class="special-card-title">{{getString('home3rdTitle')}}</h2>
            <p class="special-card-text">{{getString('home3rdSub')}}</p>
          </div>
        </div>

        <div class="special-card">
          <div class="special-card-icon">
            <span class="material-icons">card_giftcard</span>
          </div>
          <div class="special-card-content">
            <h2 class="special-card-title">{{getString('home4thTitle')}}</h2>
            <p class="special-card-text" id="giftCardsText">{{getGiftCardsText()}}</p>
          </div>
        </div>
      </div>

    </div>

  </div>

  <div class="itunes-section">
    <div class="section-content">
      <div class="section-title">{{getString('itunesMovieDealsTitle')}}</div>

      <div class="itunes-grid">
        <div class="itunes-content-card">
          <div class="itunes-card-icon">
            <span class="material-icons">local_movies</span>
          </div>
          <div class="itunes-card-body">
            <h3 class="itunes-card-title">{{getString('itunesDealsCardTitle')}}</h3>
            <div id="itunes-section-text-1" class="itunes-section-text">{{getiTunesSectionString()}}</div>
          </div>
        </div>

        <div class="itunes-content-card">
          <div class="itunes-card-icon">
            <span class="material-icons">trending_down</span>
          </div>
          <div class="itunes-card-body">
            <h3 class="itunes-card-title">{{getString('itunesMissionCardTitle')}}</h3>
            <div id="itunes-section-text-2" class="itunes-section-text"></div>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>

<div>
  <app-home-footer></app-home-footer>
</div>

<app-modal #notificationSettingsModal [title]="getString('notificationSettings')" [longModal]="true">
  <app-notification-settings *ngIf="notificationSettingsModal.isOpen" (onSuccess)="notificationSettingsModal.close()" (onAuthFail)="notificationSettingsModal.close()"></app-notification-settings>
</app-modal>
